import Button from '../../common/Button';
import type { HeroProps } from './useHero';

const HeroMobile = ({
  data,
  handlePrimaryClick,
  handleSecondaryClick,
}: HeroProps) => {
  return (
    <section className="relative min-h-[500px] w-full overflow-hidden pt-20">
      <img
        src={data.backgroundImage}
        alt="Hero background"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="bg-hero-overlay-mobile absolute inset-0" />

      <div className="relative z-10 flex min-h-[500px] flex-col justify-center px-6 py-16">
        <div className="flex flex-col gap-6">
          <h1 className="whitespace-pre-line font-heading text-[40px] font-medium italic leading-[1.1] text-foreground-inverse">
            {data.headline}
          </h1>
          <p className="whitespace-pre-line font-body text-base leading-[1.6] text-foreground-inverse/80">
            {data.subtitle}
          </p>
          <div className="flex flex-col gap-3 pt-2">
            <Button
              variant="primary"
              size="md"
              fullWidth
              onClick={handlePrimaryClick}
              className="py-4"
            >
              {data.ctaPrimary}
            </Button>
            <Button
              variant="outline"
              size="md"
              fullWidth
              onClick={handleSecondaryClick}
              className="py-4 font-medium"
            >
              {data.ctaSecondary}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroMobile;
